"use client";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { aiSummary } from "../footerMain/data";

// The footer's "Get AI summary" row: ChatGPT, Claude and Perplexity, each
// opening with a prompt to summarise the current page.
const AiSummaryLinks = () => {
  const pathname = usePathname();
  const prompt = encodeURIComponent(
    aiSummary.prompt.replace("{url}", `${aiSummary.siteUrl}${pathname}`),
  );

  return (
    <div className="flex flex-col items-center gap-3 xs:items-start">
      <h3 className="text-sm font-bold tracking-[0.06em] text-white/80 uppercase">
        {aiSummary.heading}
      </h3>
      <ul className="flex gap-3">
        {aiSummary.assistants.map((assistant) => (
          <li key={assistant.name}>
            <a
              href={assistant.href.replace("{prompt}", prompt)}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={aiSummary.linkLabel.replace("{name}", assistant.name)}
              className="grid size-11 place-items-center rounded-full bg-white shadow-card transition-transform hover:-translate-y-0.5 motion-reduce:transition-none"
            >
              <Image
                src={assistant.icon}
                alt=""
                width={24}
                height={24}
                className="size-6"
                unoptimized
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AiSummaryLinks;
